export default "__VITE_ASSET__BIxf1X0H__"